import LineChartCustom from "../../components/Incidents/charts/LineChart";

const processData = (hoursData = {}) => {
  const xLabels = Object.keys(hoursData).sort();
  const uData = xLabels.map((hour) => hoursData[hour] ?? 0);

  return { xLabels, uData };
};

const IncidentVolumeByHourChart = ({ data }) => {
  const { xLabels, uData } = processData(data);
  const series = [{ data: uData, showMark: true, curve: "linear" }];

  return <LineChartCustom xLabels={xLabels} series={series} />;
};

export default IncidentVolumeByHourChart;
